import { GridProps, SxProps, Theme } from '@mui/material';
import { defaultContainerStyling, listPageTableWrapperStyles } from '../../styles/sxStyling';
import { availabilityTileDotStyles } from '../../components/dashboard/AvailabilityPanel/availabilityPanelStyles';

export const ROW_HEIGHT = 24;
export const borderStyle = '1px solid var(--border-color)';
export const DAY_COUNT = 7;
export const DAYS_GRID_TEMPLATE = `repeat(${DAY_COUNT}, minmax(0, 1fr))`;

export const contentContainerProps: GridProps = {
  container: true,
  size: 7,
  columns: DAY_COUNT,
  sx: { py: 1 },
};

export const headerSx: SxProps = {
  textAlign: 'center',
  borderBottom: '2px solid var(--border-color)',
  position: 'sticky',
  top: 0,
  zIndex: 2,
  bgcolor: 'background.paper',
  '.MuiTypography-root': { fontWeight: 'bold' },
};

export const employeeHeaderSx: SxProps = {
  ...headerSx,
  minHeight: ROW_HEIGHT * 2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRight: borderStyle,
};

export const eventHeaderSx: SxProps = {
  height: ROW_HEIGHT,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderBottom: borderStyle,
  width: '100%',
};

export const dateCellSx: SxProps = {
  flex: 1,
  minWidth: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRight: borderStyle,
};

export const calendarWrapperSx: SxProps = {
  ...defaultContainerStyling,
  ...listPageTableWrapperStyles,
  overflow: 'hidden',
  border: borderStyle,
  bgcolor: 'background.paper',
};

export const calendarScrollableContentSx: SxProps = {
  overflowY: 'auto',
};

export const calendarToolbarSx: SxProps = {
  display: 'flex',
  alignItems: 'center',
  px: 1,
  py: 0.6,
  borderBottom: borderStyle,
  bgcolor: 'var(--table-header-bg)',
};

export const toolbarDateRangeSx: SxProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 1,
  width: '100%',
};

export const loadingContainerSx: SxProps = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: 500,
};

// Header
export const datesHeaderContainerSx = {
  ...headerSx,
  p: 0,
  display: 'flex',
  flexDirection: 'column',
  zIndex: 50,
};

export const datesHeaderGridSx = {
  display: 'grid',
  gridTemplateColumns: DAYS_GRID_TEMPLATE,
  height: ROW_HEIGHT,
};

export const datesHeaderDateCellSx = {
  ...dateCellSx,
  minWidth: 0,
};

// Schedule Row
export const scheduleRowContainerSx: SxProps<Theme> = {
  minHeight: 72,
  borderBottom: borderStyle,
};

export const scheduleRowEmployeeCellSx: SxProps<Theme> = {
  borderRight: borderStyle,
  pl: 1,
  fontSize: '0.8rem',
};

export const scheduleRowEmployeeContainerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  minHeight: 72,
};

export const scheduleRowEmployeeHeaderSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  pt: 1,
};

export const scheduleRowAvatarSx: SxProps<Theme> = {
  width: 20,
  height: 20,
};

export const scheduleRowExpandContainerSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'flex-end',
  mt: 'auto',
  pb: 0.5,
};

export const scheduleRowExpandButtonSx: SxProps<Theme> = {
  width: 'fit-content',
  p: 0.5,
  '& svg': {
    fontSize: '1rem',
  },
};

export const scheduleGridContainerSx: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: DAYS_GRID_TEMPLATE,
  gridAutoRows: 'minmax(58px, auto)',
  position: 'relative',
  minHeight: 72,
};

export const scheduleAvailabilityDotSx: SxProps<Theme> = {
  ...availabilityTileDotStyles,
  position: 'absolute',
  top: 10,
  left: '50%',
  transform: 'translateX(-50%)',
  zIndex: 1,
};

export const scheduleEventTileContainerSx: SxProps<Theme> = {
  minWidth: 0,
  m: 0.75,
  mt: 2.75,
  zIndex: 2,
};

export const scheduleDayBackgroundSx: SxProps<Theme> = {
  minHeight: 58,
  position: 'relative',
};

export const scheduleConflictIconSx: SxProps<Theme> = {
  position: 'absolute',
  top: 4,
  left: '50%',
  transform: 'translateX(-50%)',
  fontSize: 16,
  zIndex: 1,
};

export const scheduleAvailabilityDotCenteredSx: SxProps<Theme> = {
  ...scheduleAvailabilityDotSx,
  top: '50%',
  transform: 'translate(-50%, -50%)',
};
